<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.unidade"
                    disabled
                    label="Unidade"
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.infraestrutura"
                    disabled
                    label="Local de atendimento"
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    created() {
        this.repositories = {
            tela: this.getConectaSusRepository('painelSenha.tela')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.tela.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(
                            {
                                unidade: [{
                                    id: this.lotacao.infraestrutura.unidade.id,
                                    nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                                }],
                                infraestrutura: [{
                                    id: this.lotacao.infraestrutura.id,
                                    nome: this.lotacao.infraestrutura.nome,
                                }],
                            },
                        )

                        this.model = Object.assign(
                            {
                                unidadeId: this.lotacao.infraestrutura.unidade.id,
                                infraestruturaId: this.lotacao.infraestrutura.id,
                            },
                            response.data.model,
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.tela.create()
                    .then(response => {
                        this.form = Object.assign(
                            {
                                unidade: [{
                                    id: this.lotacao.infraestrutura.unidade.id,
                                    nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                                }],
                                infraestrutura: [{
                                    id: this.lotacao.infraestrutura.id,
                                    nome: this.lotacao.infraestrutura.nome,
                                }],
                            },
                            response.data.form,
                        )

                        this.model = Object.assign(
                            {
                                unidadeId: this.lotacao.infraestrutura.unidade.id,
                                infraestruturaId: this.lotacao.infraestrutura.id,
                            },
                            response.data.model,
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    if (this.model.id) {

                        this.repositories.tela
                            .update(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())

                    } else {

                        this.repositories.tela.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>